import { render, staticRenderFns } from "./counters.vue?vue&type=template&id=63a78c61&"
import script from "./counters.vue?vue&type=script&lang=js&"
export * from "./counters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports